// extracted by mini-css-extract-plugin
module.exports = {"chart":"styles_chart__2lw0O"};